import * as angular from 'angular';
import * as d3 from 'd3';

import { ComponentDefinition } from '../../models';
import { PercentageEvolutionBase } from './percentageEvolutionBase';
import { ILoggerService } from '../../services';
import { infoTextColor } from '../../common/constants';

class PercentageEvolutionController extends PercentageEvolutionBase implements angular.IComponentController {
    item: any;

    static $inject = ['$scope', 'loggerService'];

    constructor($scope: angular.IScope,
        private loggerService: ILoggerService) {
        super($scope);
    }

    $onInit() {
        super.$onInit();
        this.series.push({
            name: this.item.name.replace(' evolution', ''),
            color: infoTextColor,
            identifier: 0,
            value: d => d.value,
            selector: () => 0,
            isVisible: true,
            isLineVisible: true,
            crosshairFormat: d => d3.format('2.2%')(d.value)
        });
        this.readData();
    }

    readData(guid?: string): void {
        const self = this;
        this.isLoading = true;
        try {
            this.item.readData(guid).then(
                (response) => {
                    self.data = response;
                },
                (reason) => {
                    self.loggerService.logError(reason);
                }
            ).then(
                () => {
                    self.isLoading = false;
                }
            ).catch(() => {
                self.isLoading = false;
            });
        } catch (e) {
            this.loggerService.logError(e);
            this.isLoading = false;
        }
    }
}

export const wtPercentageEvolution: ComponentDefinition = {
    componentId: 'wtPercentageEvolution',
    controller: PercentageEvolutionController,
    template: require('./percentageEvolution.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '<'
    }
};
